import {
  AFFINE_CANVAS_PERFORMANCE_OVERLAY,
  AffineCanvasPerformanceOverlay,
} from './canvas-performance-overlay';
import {
  AFFINE_VIEWPORT_OVERLAY_WIDGET,
  AffineViewportOverlayWidget,
} from './index';

export function effects() {
  customElements.define(
    AFFINE_CANVAS_PERFORMANCE_OVERLAY,
    AffineCanvasPerformanceOverlay
  );
  customElements.define(
    AFFINE_VIEWPORT_OVERLAY_WIDGET,
    AffineViewportOverlayWidget
  );
}
